import Instance from "../axios/Instance";

export const getSubject = () => {
    return Instance.get('/application/subject').then(response => response);
}
export const getCommercialStructure = (stId, cycle, code) => {
    return Instance.get(`/application/commercialStructure/menu?stId=${stId}&cycle=${cycle}&code=${code}`).then(response => response);
}
export const getStCycles = (id) => {
    return Instance.get(`/application/stcycles?id=${id}`).then(response => response);
}
